import React from 'react';
import './TransactionFilters.css';

interface TransactionFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  methodFilter: string;
  onMethodFilterChange: (method: string) => void;
}

const TransactionFilters: React.FC<TransactionFiltersProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  methodFilter,
  onMethodFilterChange,
}) => {
  return (
    <div className="transaction-filters">
      <div className="transaction-search">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search by transaction ID, order, customer..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="transaction-search-input"
        />
      </div>
      <div className="transaction-filter-controls">
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="transaction-filter-select"
        >
          <option>All Status</option>
          <option>Completed</option>
          <option>Pending</option>
          <option>Failed</option>
          <option>Refunded</option>
        </select>
        <select
          value={methodFilter}
          onChange={(e) => onMethodFilterChange(e.target.value)}
          className="transaction-filter-select"
        >
          <option>All Methods</option>
          <option>Credit Card</option>
          <option>Debit Card</option>
          <option>Digital Wallet</option>
        </select>
        <button className="transaction-more-filters-btn">
          <span>🔽</span> More Filters
        </button>
      </div>
    </div>
  );
};

export default TransactionFilters;

